import { Building2, User } from 'lucide-react';
import { Controller, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { Button } from '@/components/shadcn/button';
import { FieldLabel } from '@/components/shadcn/field';
import { RadioGroup, RadioGroupItem } from '@/components/shadcn/radio-group';

export default function PartyTypeToggle() {
  const { t } = useTranslation();

  const { control } = useFormContext();

  return (
    <Controller
      control={control}
      name="entityType"
      render={({ field }) => (
        <div className="rounded-lg border p-1">
          <RadioGroup
            className="flex gap-1"
            value={field.value}
            onValueChange={field.onChange}
          >
            <FieldLabel htmlFor="natural" className="grow bg-transparent!">
              <Button
                className="w-full"
                variant={field.value === 'NATURAL' ? 'default' : 'ghost'}
                asChild
              >
                <span>
                  <User className="size-4" />
                  {t('PARTY_CREATE_INLINE_TYPE_CUSTOMER')}
                </span>
              </Button>

              <RadioGroupItem value="NATURAL" id="natural" hidden />
            </FieldLabel>

            <FieldLabel htmlFor="legal" className="grow bg-transparent!">
              <Button
                className="w-full"
                variant={field.value === 'LEGAL' ? 'default' : 'ghost'}
                asChild
              >
                <span>
                  <Building2 className="size-4" />
                  {t('PARTY_CREATE_INLINE_TYPE_COMPANY')}
                </span>
              </Button>

              <RadioGroupItem value="LEGAL" id="legal" hidden />
            </FieldLabel>
          </RadioGroup>
        </div>
      )}
    />
  );
}
